import { Box, Flex, Paragraph, Button } from 'theme-ui';
import { useSelectedOptions, useSelectedOptionIsAvailable } from '@hooks';

import { themed } from './Option.theme';

export const Option = themed(({ theme, options, optionName }) => {
  const [selectedOptions, setSelectedOptions] = useSelectedOptions();
  const selectedOptionIsAvailable = useSelectedOptionIsAvailable();

  const selectedOption = selectedOptions?.[optionName];

  return (
    <Box data-comp={`${Option.displayName}-${optionName}`} sx={theme.option}>
      {/* Sizes, Colors .. */}
      <Flex sx={theme.header}>
        <Paragraph sx={theme.name}>{optionName}</Paragraph>
        <Paragraph sx={theme.selectedOption}>{selectedOption}</Paragraph>
      </Flex>

      {/* e.g 50cm, 54cm... */}
      <Flex as="ul" sx={theme.values}>
        {options[optionName]?.map((value) => {
          const isSelected = selectedOptions?.[optionName] === value;
          const isAvailable = selectedOptionIsAvailable({
            [optionName]: value,
          });
          return (
            <Box key={value} as="li">
              <Button
                variant="buttons.plain"
                onClick={() => {
                  setSelectedOptions({ [optionName]: value });
                }}
                sx={{
                  ...theme.value,
                  ...(isAvailable
                    ? isSelected
                      ? theme.value.available.selected
                      : theme.value.available.unselected
                    : isSelected
                    ? theme.value.unavailable.selected
                    : theme.value.unavailable.unselected),
                }}
              >
                {value}
              </Button>
            </Box>
          );
        })}
      </Flex>
    </Box>
  );
});

Option.displayName = 'Option';
